export interface AgenciesWithFilmmakers {
  AgencyRefNumber: number;
  AgencyName: string;
  FilmmakersAgencyId: number | null;
}

export const mapJsonToAgenciesWithFilmmakers = (
  jsonString: string
): AgenciesWithFilmmakers[] => {
  try {
    const arr = JSON.parse(jsonString);

    return arr.map((item: any) => ({
      AgencyRefNumber: Number(item.AgencyRefNumber),
      AgencyName: String(item.AgencyName),
      FilmmakersAgencyId:
        typeof item.FilmmakersAgencyId === "number"
          ? item.FilmmakersAgencyId
          : null,
    }));
  } catch {
    return [];
  }
};